
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetopanchgani() {



    const cardData =
    {
        keyword: '  Pune to Panchgani Cab Fare',
        heading: 'Mauli Cabs: Pune to Panchgani Cab Fare',
        headingDescription: 'Mauli Cabs offers transparent and affordable Pune to Panchgani cab fare, ensuring a comfortable and budget-friendly travel experience to the beautiful hill station of Panchgani. Whether you are planning a relaxing holiday or a quick getaway, we provide a wide range of vehicles including sedans, SUVs, and Ertiga cabs to suit your needs. With professional drivers, no hidden charges, clear pricing, and a focus on customer satisfaction, Mauli Cabs guarantees a smooth, safe, and enjoyable journey from Pune to Panchgani at the best cab fares.',

        top: 'Top Places to Visit in Panchgani with Mauli Cabs',

"topPlaces": [
    {
        "title": "Table Land",
        "description": "Table Land is the second-longest mountain plateau in Asia, located at an elevation of 1,387 meters above sea level. It offers panoramic views of the surrounding valleys and hills, making it a popular spot for picnics and paragliding."
    },
    {
        "title": "Sydney Point",
        "description": "Situated approximately 2 km from the Panchgani bus stand, Sydney Point offers a breathtaking view of the Krishna Valley and the Dhom Dam. It's an ideal spot for sunset photography and leisurely walks."
    },
    {
        "title": "Kate's Point",
        "description": "Located about 9 km from Panchgani, Kate's Point provides stunning views of the Krishna Valley, Dhom Dam, and the surrounding hills. It's named after the daughter of then British Governor Sir John Malcolm."
    },
    {
        "title": "Parsi Point",
        "description": "Situated on the Mahabaleshwar road, Parsi Point offers a scenic view of the Krishna Valley and the Dhom Dam backwaters. It's a popular spot for picnics and photography."
    },
    {
        "title": "Dhom Dam",
        "description": "Dhom Dam is a gravity dam located on the Krishna River near Wai, approximately 21 km from Panchgani. It's a serene spot for boating and enjoying the natural beauty of the surroundings."
    },
    {
        "title": "Rajpuri Caves",
        "description": "Rajpuri Caves are ancient caves located near Panchgani. The caves are surrounded by lakes and are believed to have been used by the Pandavas during their exile, adding a mystical charm to the site."
    },
    {
        "title": "Mapro Garden",
        "description": "Mapro Garden is a popular tourist attraction known for its strawberry production and delicious fruit-based products. The garden features a restaurant, nursery, and a retail outlet selling Mapro products."
    },
    {
        "title": "Devrai Art Village",
        "description": "Devrai Art Village is a cultural center dedicated to preserving and promoting traditional Warli tribal art. Visitors can explore the gallery, participate in workshops, and purchase handmade art pieces."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is located on the Mahabaleshwar-Pune road and offers a picturesque view of the surrounding landscape. The waterfall is a popular spot for nature lovers and photographers."
    },
    {
        "title": "Panchgani's Strawberry Farms",
        "description": "Panchgani's strawberry farms are famous for their fresh and delicious strawberries. Visitors can enjoy strawberry picking, taste fresh strawberries, and purchase strawberry-based products."
    }
],

"services": [
    {
      "name": "Pune to Panchgani Cab Fare",
      "description": "The fare for a cab from Pune to Panchgani varies depending on the type of vehicle, distance, and duration of the trip. Get an affordable and competitive rate for your comfortable journey to Panchgani."
    },
    {
      "name": "Pune to Panchgani Taxi Rates",
      "description": "Our taxi rates from Pune to Panchgani are transparent and competitive. We offer a variety of vehicles, ranging from economy to luxury, so you can choose the option that fits your budget and preferences."
    },
    {
      "name": "Pune to Panchgani Cab Charges",
      "description": "The charges for a cab from Pune to Panchgani depend on the vehicle type, the route taken, and the duration of the trip. Our cab services provide you with upfront pricing with no hidden charges."
    },
    {
      "name": "Pune to Panchgani Taxi Fare to Parsi Point",
      "description": "If you're traveling from Pune to Panchgani to visit the famous Parsi Point, our taxi fare is affordable and provides comfort for the scenic journey. Book a reliable cab to reach Parsi Point in style and comfort."
    },
    {
      "name": "Pune to Panchgani Cab Pricing",
      "description": "We offer competitive pricing for cabs from Pune to Panchgani. Whether you choose a budget-friendly vehicle or a more luxurious ride, our pricing ensures that you travel without breaking the bank."
    },
    {
      "name": "Pune to Panchgani Taxi Fare Katas Point",
      "description": "Travel to Katas Point in Panchgani with our taxi services. Enjoy the scenic beauty of the area while traveling comfortably. The fare from Pune to Panchgani's Katas Point is affordable and varies based on vehicle type."
    },
    {
      "name": "Pune to Panchgani Cab to Sydney Point",
      "description": "Visit the famous Sydney Point in Panchgani with a comfortable and affordable taxi ride. Our cabs are available for direct transportation to Sydney Point, ensuring you enjoy a relaxing journey with a spectacular view."
    },
    {
      "name": "Pune to Panchgani Taxi Fare List",
      "description": "We provide a detailed fare list for all types of taxis from Pune to Panchgani. Whether you opt for a budget cab or a premium option, our fare list ensures you can make an informed decision for your travel."
    },
    {
      "name": "Pune to Panchgani Cab Cost",
      "description": "The cost for a cab from Pune to Panchgani is dependent on vehicle selection, route, and duration. Our services offer affordable options with transparent pricing, so you can enjoy a smooth journey."
    },
    {
      "name": "Pune to Panchgani Cab Fare",
      "description": "The cab fare from Pune to Panchgani is calculated based on the vehicle type and the distance traveled. We offer competitive pricing to ensure you have a pleasant and cost-effective travel experience."
    },
    {
      "name": "Pune Airport to Panchgani Taxi Fare",
      "description": "The fare for a taxi from Pune Airport to Panchgani varies based on the type of vehicle and the route. Our taxi service offers a hassle-free and comfortable ride from Pune Airport to Panchgani at affordable rates."
    },
    {
      "name": "Pune to Panchgani Distance by Taxi Fare",
      "description": "The distance from Pune to Panchgani by taxi is approximately 98 km, and the fare is dependent on vehicle type and the duration of your trip. We provide cost-effective taxi services to ensure a smooth ride."
    },
    {
      "name": "Pune to Panchgani Taxi Fare",
      "description": "Our taxi fare for traveling from Pune to Panchgani is affordable, offering a variety of vehicles to suit your needs. The fare is calculated based on distance and vehicle type, with no hidden charges."
    },
    {
      "name": "Pune to Panchgani Cab",
      "description": "Book a comfortable cab from Pune to Panchgani. We offer a range of vehicles, from budget-friendly options to premium rides, ensuring a comfortable and relaxing journey to your destination."
    },
    {
      "name": "Pune Airport to Panchgani Taxi Fare",
      "description": "The fare for a taxi from Pune Airport to Panchgani is based on vehicle selection, distance, and travel time. We provide a smooth and comfortable ride with competitive pricing to and from Pune Airport."
    },
    {
      "name": "Pune to Panchgani Cab Fare",
      "description": "Book a cab from Pune to Panchgani with transparent pricing. The fare will depend on the vehicle type, travel distance, and duration of the trip, ensuring a hassle-free journey at affordable rates."
    },
    {
      "name": "Pune to Panchgani Distance by Taxi Fare",
      "description": "The distance from Pune to Panchgani is around 98 km, and our taxi fares are based on the vehicle type and duration of the journey. Get affordable rates for your trip from Pune to Panchgani."
    },
    {
      "name": "Pune to Panchgani Ertiga Cab",
      "description": "Travel in style and comfort with our Ertiga cab service from Pune to Panchgani. With ample space and modern amenities, our Ertiga cabs ensure a relaxing journey to Panchgani for families and groups."
    },
    {
      "name": "Pune to Panchgani Taxi",
      "description": "We offer comfortable taxi services from Pune to Panchgani, providing a smooth and scenic ride. Our taxis are available in a variety of vehicle types to meet your travel preferences."
    },
    {
      "name": "Pune to Panchgani Taxi Distance",
      "description": "The distance from Pune to Panchgani by taxi is approximately 98 km, and we offer affordable rates for your journey. Our drivers are familiar with the best routes to ensure you arrive in comfort and on time."
    },
    {
      "name": "Pune to Panchgani Taxi Fare",
      "description": "Our taxi fare for trips from Pune to Panchgani depends on the vehicle type, distance, and duration of the journey. We provide competitive rates with no hidden charges for a seamless travel experience."
    },
    {
      "name": "Pune to Panchgani Drop Taxi",
      "description": "For those looking for a one-way trip, our drop taxi service from Pune to Panchgani is ideal. You can choose from a range of vehicles based on your budget, and enjoy a comfortable, direct ride to Panchgani."
    }
  ],
  "tableData": [
    ["Pune to Panchgani Cab Fare", "Pune to Panchgani Taxi Rates"],
    ["Pune to Panchgani Cab Charges", "Pune to Panchgani Taxi Fare to Parsi Point"],
    ["Pune to Panchgani Cab Pricing", "Pune to Panchgani Taxi Fare Katas Point"],
    ["Pune to Panchgani Cab to Sydney Point", "Pune to Panchgani Taxi Fare List"],
    ["Pune to Panchgani Cab Cost", "Pune to Panchgani Cab Fare"],
    ["Pune to Panchgani Taxi Fare", "Pune Airport to Panchgani Taxi Fare"],
    ["Pune to Panchgani Distance by Taxi Fare", "Pune to Panchgani Taxi"],
    ["Pune to Panchgani Taxi Distance", "Pune to Panchgani Ertiga Cab"],
    ["Pune to Panchgani Taxi Fare", "Pune to Panchgani Drop Taxi"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Panchgani journey. We ensure there are no hidden charges, with clear, upfront pricing. You can be confident that the fare you see is the fare you pay, making your travel budget-friendly and hassle-free."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Choose From",
        "WhyChoosedescription": "We offer a variety of vehicles for your Pune to Panchgani cab ride, including budget-friendly sedans, spacious SUVs, and premium cars. You can select the vehicle that best suits your preferences and budget, ensuring comfort throughout the journey."
    },
    {
        "WhyChooseheading": "Competitive Pricing for Short and Long Trips",
        "WhyChoosedescription": "Mauli Cabs provides competitive pricing for both short and long trips. Whether you’re heading to Panchgani for a quick getaway or a longer vacation, we offer reasonable fares to make your trip affordable without compromising on quality or comfort."
    },
    {
        "WhyChooseheading": "No Hidden Charges",
        "WhyChoosedescription": "We believe in complete transparency. Our fares include all charges, including fuel, tolls, and taxes, so there are no surprises at the end of your trip. What you’re quoted is exactly what you’ll pay for your Pune to Panchgani cab."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Ride",
        "WhyChoosedescription": "Mauli Cabs ensures a safe and comfortable ride to Panchgani with well-maintained vehicles equipped with modern safety features. All our cabs have air conditioning, ample space, and are driven by professional drivers who ensure a smooth and enjoyable trip."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "We offer flexible payment options, so you can easily pay via cash, card, or through our mobile app. This makes the payment process convenient and quick, allowing you to focus on enjoying your ride to Panchgani."
    },
    {
        "WhyChooseheading": "Easy Booking and Fare Estimation",
        "WhyChoosedescription": "Booking your Pune to Panchgani cab with Mauli Cabs is simple. You can check the fare estimate through our website or app before booking. Our user-friendly booking platform allows you to plan your trip with ease, and you’ll receive an accurate fare estimate for your ride."
    },
    {
        "WhyChooseheading": "Special Discounts on Return Trips",
        "WhyChoosedescription": "Mauli Cabs offers special discounts on return trips from Panchgani to Pune, helping you save money on round trips. Ask about our return trip discounts when booking your Pune to Panchgani cab!"
    }
]



























    }


    const faqData = [
        {
            question: 'What is the fare for a cab from Pune to Panchgani?',
            answer: 'The fare for a cab from Pune to Panchgani depends on the type of vehicle you choose. For example, fares for Sedans are generally more affordable, while SUVs, Ertiga, or Innova Crysta may cost more. The total fare will be calculated based on distance, tolls, taxes, and other applicable charges. You can get an exact fare estimate by booking through our website or mobile app.',
        },
        {
            question: 'Is the Pune to Panchgani cab fare fixed?',
            answer: 'Yes, the fare for the Pune to Panchgani trip is fixed and transparent. The fare includes all charges such as tolls, taxes, driver fees, and any other applicable charges. You will know the total fare upfront before confirming your booking, with no hidden costs.',
        },
        {
            question: 'Does Mauli Cabs offer discounts or offers on Pune to Panchgani fares?',
            answer: 'Yes, Mauli Cabs often provides special discounts and promotions for bookings, including for trips from Pune to Panchgani. You can check our website or app for current offers or contact our customer support team for more information.',
        },
        {
            question: 'Are there any extra charges for the Pune to Panchgani trip?',
            answer: 'The fare you see at the time of booking includes all standard charges such as taxes, tolls, and driver fees. However, additional charges may apply if there are extra stops, extended waiting times, or if the route takes longer than expected due to traffic conditions. You’ll be informed about any extra charges before your journey begins.',
        },
        {
            question: 'Can I book a round-trip cab from Pune to Panchgani?',
            answer: 'Yes, you can easily book a round-trip cab from Pune to Panchgani. Just provide your return details during the booking process, and we’ll ensure a smooth and comfortable round trip for you.',
        },
        {
            question: 'How long does the trip from Pune to Panchgani take?',
            answer: 'The trip from Pune to Panchgani typically takes around 3 to 4 hours, depending on traffic conditions and the chosen route. The journey is scenic and offers beautiful views, making it an enjoyable ride.',
        },
        {
            question: 'Are the cabs for the Pune to Panchgani trip air-conditioned?',
            answer: 'Yes, all our cabs for the Pune to Panchgani trip are air-conditioned and well-maintained to ensure comfort throughout the journey. We prioritize cleanliness and hygiene to make sure you have a pleasant experience.',
        },
        {
            question: 'Can I make stops during my Pune to Panchgani trip?',
            answer: 'Yes, you can make stops along the way for sightseeing, meals, or rest breaks. Our drivers are flexible and will accommodate your requests to ensure a comfortable and enjoyable trip.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Panchgani trip?',
            answer: 'Mauli Cabs offers affordable, fixed fares with no hidden charges, a variety of vehicles for different needs, professional drivers, and a commitment to customer satisfaction. Whether you’re traveling for leisure or business, we ensure a comfortable, safe, and hassle-free journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Raghav Patel",
            position: "Leisure Traveler",
            text: "I traveled with Mauli Cabs from Pune to Panchgani, and it was an excellent experience. The fare was reasonable, and the driver was courteous and professional. The ride was comfortable, and we made a few scenic stops along the way. Highly recommend!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Sneha Joshi",
            position: "Tourist",
            text: "My family and I booked a cab with Mauli Cabs for a trip from Pune to Panchgani, and the service was great. The vehicle was clean, air-conditioned, and very comfortable. The driver knew the route well, and we had a smooth journey. I would definitely book with them again.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   



    return (
        <div>
            <GTag/>


<Helmet>
  <title>Pune to Panchgani Cab Fare | Book Affordable Taxi from Pune to Panchgani</title>
  <meta
    name="description"
    content="Get the best Pune to Panchgani cab fare with reliable taxi services. Book your taxi from Pune to Panchgani, including popular points like Parsi Point, Kates Point, and Sydney Point. Affordable and comfortable travel options."
  />
  <meta
    name="keywords"
    content="Pune to Panchgani Cab Fare, Pune to Panchgani Taxi Rates, Pune to Panchgani Taxi Charges, Pune to Panchgani Distance by Taxi Fare, Pune to Panchgani Cab Pricing, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Ertiga Cab"
  />
</Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopanchgani;